import { Controller } from "@hotwired/stimulus"

// Interactive star rating.
// data-star-rating-target="star" on each button, data-star-value="N" for the star number.
// data-star-rating-target="input" on the hidden input holding the value.
export default class extends Controller {
  static targets = ["star", "input", "label"]
  static values = { selected: Number }

  connect() {
    this.selectedValue = parseInt(this.inputTarget.value) || 0
    this._render(this.selectedValue)
  }

  hover(event) {
    const val = parseInt(event.currentTarget.dataset.starValue)
    this._render(val)
  }

  leave() {
    this._render(this.selectedValue)
  }

  select(event) {
    const val = parseInt(event.currentTarget.dataset.starValue)
    this.selectedValue = val
    this.inputTarget.value = val
    this._render(val)
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  _render(filled) {
    this.starTargets.forEach((btn, i) => {
      const active = i + 1 <= filled
      const svg = btn.querySelector("svg")
      if (svg) {
        svg.style.color = active ? "#f59e0b" : "#e2e8f0"
        svg.style.fill = active ? "#f59e0b" : "#e2e8f0"
        svg.style.transform = active ? "scale(1.15)" : "scale(1)"
      }
    })

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = filled > 0 ? `${filled}/5` : ""
    }
  }
}
